import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8000/",
  //  baseURL: "http://103.13.211.35:82/",
  baseURL: "http://102.220.22.97:8000/",
  headers: {
    "Content-Type":
      "multipart/form-data; boundary=<calculated when request is sent>",
    "Access-Control-Allow-Origin": "*",
    Accept: "*/*",
    // Authorization: "Bearer " + window.sessionStorage.getItem("xtoken"),
  },
});
